import React, { ReactElement } from 'react';
import url from 'url';
import { isEven } from '../const/util';
import * as social from '../const/social';
import { ProjectData } from '../interfaces';

import styles from '../assets/styles/projects.module.scss';
import { ThumbnailContext } from '../const/contexts';
import { server } from '../const/axios';

const validLinkRegex = /^(website|github|npm|devpost)/;

export default class TextBox extends React.Component<ProjectData> {

	generateLinks(): (ReactElement | null)[] {
		if (!this.props.thumbs) return [];
		return this.props.thumbs.map(({type, href}, i) => {
			if (!validLinkRegex.test(type)) return null;
			let [, k] = type.match(validLinkRegex) as [string, 'website' | 'github' | 'npm' | 'devpost'];
			return (
				<a
					key={this.props.id + '.' + this.props.i + '.TextBox.a.' + i}
					id={k}
					href={href}
					rel='noopener noreferrer'
					target='_blank'
				>
					<img alt={k + '_logo'} src={social[k]}/>
				</a>
			);
		});
	}

	render(): ReactElement {
		return (
			<div
				className={[styles.textBox, styles['project-text']].join(' ')}
				style={Object.assign({}, this.props.style, {
					backgroundColor: this.props.colour || '#002147'
				})}
			>
				<ThumbnailContext.Consumer>
					{thumbs => <div className={[styles.links, styles.prefix].join(' ')}>
						{(this.props.dependencies || []).map(key => {
							return key in thumbs ?
								<a key={this.props.id + '.' + key} href={url.resolve(process.env.PUBLIC_URL, thumbs[key].uri || '')} rel="noopener noreferrer" target="_blank">
									<img
										alt={thumbs[key].alt}
										src={url.resolve(server + '/thumbnails/', thumbs[key].src)}
										style={thumbs[key].style}
									></img>
								</a>
							: null}
						)}
					</div>}
				</ThumbnailContext.Consumer>
				<h1>
					{this.props.title.includes('**') ?
						this.props.title.split('**').map((element, i) => {
							if (isEven(i)) return element;
							else return <span key={element + '.' + i} className='bold'>{element}</span> 
						})
					: this.props.title}
				</h1>
				<h4 className='description'>
					{this.props.description}
				</h4>
				{
					(Object.entries(this.props.status || {})).map(([k, v]) => {
						return (
							<h4 key={this.props.id + '.description.' + k} className={styles.status}>{k === 'status' ? v : k + ': ' + v}</h4>
						)
					})
				}
				<div className={[styles.links, styles.suffix].join(' ')}>
					{this.generateLinks()}
				</div>
			</div>
		)
	}
}